
import Head from 'next/head'
import styles from './index.module.css';
import utils from '../util/utils';
import Product from '../util/product';

const PRD_LIST = {

    211001: { // 天气云云
        screenshot: 'https://cdn.gzzhitui.com/jiliang-bucket/imgUpload/c783e6384e4d006df7fa9aeeaa89b6ac_sh.png',
        company: '陈永艳',
        logo: 'https://cdn.gzzhitui.com/jiliang-bucket/imgUpload/4f716a2091cc22308f2053ddc4f45ddc_log.png',
        apk: '',
        detail: `一聊天就开始不知道所措，看到对方的消息不知怎么回复，快使用恋小知，高情商回复做你恋爱嘴替 【恋小知】高情商键盘，助你轻松追爱 【完美人设】多种风格人设，任你选择 【亲密关系】分析追爱进展，把握尺度 【全面聊天】全场景话术，做你的恋爱嘴替`,
        title: '恋小知',
        slogan: '恋小知'
    },

    21100: { // 答题闯天下
        screenshot: '',
        company: '广州迈远信息科技有限公司',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_21100_market.png',
        apk: 'https://down.xmiles.cn/down/21100/920303',
        detail: '这是一款结合成语、常识题目的益智休闲产品，通过复古的画风、诙谐的原创题目，寓教于乐，让你在游戏的过程中体验到学习知识的乐趣。'
    },
    21102: { // 答题小侠客
        screenshot: '',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_21102.png',
        apk: 'https://down.xmiles.cn/down/21102/1170000',
        detail: '这是一款结合成语、常识题目的益智休闲产品，通过复古的画风、诙谐的原创题目，寓教于乐，让你在游戏的过程中体验到学习知识的乐趣。'
    },
    21103: { // 答题智闯关
        screenshot: '',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_21103.png',
        apk: 'https://down.xmiles.cn/down/21103/1180000',
        detail: '这是一款结合成语、常识题目的益智休闲产品，通过复古的画风、诙谐的原创题目，寓教于乐，让你在游戏的过程中体验到学习知识的乐趣。'
    },
    21104: { // 糊涂答题侠客
        screenshot: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/img_21104.png',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_21104.png',
        apk: '',
        detail: '这是一款结合成语、常识题目的益智休闲产品，通过复古的画风、诙谐的原创题目，寓教于乐，让你在游戏的过程中体验到学习知识的乐趣。'
    },
    21105: { // 答题大侠
        screenshot: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/img_21105.png',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_21105.png',
        apk: '',
        detail: '这是一款结合成语、常识题目的益智休闲产品，通过复古的画风、诙谐的原创题目，寓教于乐，让你在游戏的过程中体验到学习知识的乐趣。'
    },
    21106: { // 开心答人
        screenshot: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/img_21106.png',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_21106.png',
        apk: 'https://husangamerelease.yingzhongshare.com/apk/questionmany/questionmany_1550002.apk',
        detail: '这是一款结合成语、常识题目的益智休闲产品，通过复古的画风、诙谐的原创题目，寓教于乐，让你在游戏的过程中体验到学习知识的乐趣。'
    },
    211060: { // 开心答人
        screenshot: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/img_21106.png',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_21106.png',
        apk: 'https://husangamerelease.yingzhongshare.com/apk/questionmany/questionmany_1550002.apk',
        detail: '这是一款结合成语、常识题目的益智休闲产品，通过复古的画风、诙谐的原创题目，寓教于乐，让你在游戏的过程中体验到学习知识的乐趣。'
    },
    26000: { // 极致清理管家
        screenshot: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/img_26000.png',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_26000.png',
        apk: '',
        detail: '这是一款专业的手机清理优化加速工具，再顽固的应用垃圾都能轻松清楚！是清除内存垃圾的好助手，是你身边最贴心的清理大师！'
    },
    26001: { // AT清理大师
        screenshot: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/img_26001.png',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_26001.png',
        apk: '',
        detail: '这是一款专业的手机清理优化加速工具，再顽固的应用垃圾都能轻松清楚！是清除内存垃圾的好助手，是你身边最贴心的清理大师！'
    },
    26004: { // 清理球
        screenshot: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/img_26004.png',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_26004.png',
        apk: '',
        detail: '这是一款专业的手机清理优化加速工具，再顽固的应用垃圾都能轻松清楚！是清除内存垃圾的好助手，是你身边最贴心的清理大师！'
    },
    260040: { // 清理球(微信开放平台)
        screenshot: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/img_26004.png',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_26004.png',
        apk: '',
        detail: '这是一款专业的手机清理优化加速工具，再顽固的应用垃圾都能轻松清楚！是清除内存垃圾的好助手，是你身边最贴心的清理大师！'
    },
    26005: { // 清理星
        screenshot: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/img_26005.png',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_26005.png',
        apk: '',
        detail: '这是一款专业的手机清理优化加速工具，再顽固的应用垃圾都能轻松清楚！是清除内存垃圾的好助手，是你身边最贴心的清理大师！'
    },
    260050: { // 清理星(微信开放平台)
        screenshot: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/img_26005.png',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_26005.png',
        apk: '',
        detail: '这是一款专业的手机清理优化加速工具，再顽固的应用垃圾都能轻松清楚！是清除内存垃圾的好助手，是你身边最贴心的清理大师！'
    },
    26006: { // 爱上清理球
        screenshot: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/img_26006.png',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_26006.png',
        apk: '',
        detail: '这是一款专业的手机清理优化加速工具，再顽固的应用垃圾都能轻松清楚！是清除内存垃圾的好助手，是你身边最贴心的清理大师！'
    },
    26002: { // 极致清理大师
        screenshot: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/img_26002.png',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_26002.png',
        apk: '',
        detail: '这是一款专业的手机清理优化加速工具，再顽固的应用垃圾都能轻松清楚！是清除内存垃圾的好助手，是你身边最贴心的清理大师！'
    },
    26007: { // 爱上清理星
        screenshot: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/img_26007.png',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_26007.png',
        apk: '',
        detail: '这是一款专业的手机清理优化加速工具，再顽固的应用垃圾都能轻松清楚！是清除内存垃圾的好助手，是你身边最贴心的清理大师！'
    },
    260070: { // 爱上清理星
        screenshot: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/img_26007.png',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_26007.png',
        apk: '',
        detail: '这是一款专业的手机清理优化加速工具，再顽固的应用垃圾都能轻松清楚！是清除内存垃圾的好助手，是你身边最贴心的清理大师！'
    },
    310100: { // 上网得宝
        screenshot: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/img_310100.png',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_310100.png',
        apk: '',
        detail: '上网得宝是一款智能网络安全工具，能保障网络不泄露隐私信息，智能防止各种流氓软件侵扰，同时也能防止别人蹭网，是你贴心的网络守护大师！'
    },
    3101000: { // 上网得宝
        screenshot: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/img_310100.png',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_310100.png',
        apk: '',
        detail: '上网得宝是一款智能网络安全工具，能保障网络不泄露隐私信息，智能防止各种流氓软件侵扰，同时也能防止别人蹭网，是你贴心的网络守护大师！'
    },
    210101: { // 今晚迎财神
        screenshot: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/img_210101.png',
        logo: 'https://husangamerelease.yingzhongshare.com/img/officialWebsite/logo_210101.png',
        apk: '',
        detail: '《今夜迎财神》是一款中国风休闲合成小游戏，玩家通过收集合成，解锁和升级新财神，游戏玩法简单，基调轻松，适合全年龄层玩家休闲娱乐。',
        title: '今晚迎财神',
        slogan: '牛年迎财神，财运请进门',
    }
}

class Index extends React.Component {
    constructor(props) {
        super(props);
    }

    static async getInitialProps({ req }) {
        let { prdid = 211001 } = req.query;
        let appInfo = utils.getAppInfo(prdid);
        console.log(appInfo)
        let appDetail = PRD_LIST[prdid];
        console.log(prdid)
        return { prdid, appInfo, appDetail };
    }

    toast() {
        alert('正在开发中，敬请期待');
    }

    render() {
        const { prdid, appInfo, appDetail } = this.props;
        console.log(this.props)
        if (!appInfo || !appDetail) {
            return '网站建设中...';
        }
        const { name, icp } = appInfo;
        const { detail, screenshot, logo, apk, title, slogan, company, protocolAddress } = appDetail;
        let isClean = Product.isAppClear({ prdid: prdid });

        return <div className={styles.main}>
            {/* <div className={styles.fullscene}> */}
            {
                isClean ? <>
                    <div className={styles.cleanRightTop}></div>
                    <div className={styles.cleanLeftBottom}></div>
                </> :
                    <>
                        <div className={styles.rightTop}></div>
                        <div className={styles.leftBottom}></div>
                    </>
            }

            {/* </div> */}

            <Head>
                <title>{name}官网</title>
            </Head>
            {/* <img className={styles.company} src={utils.getPublicPath(`/img/index/${company}.png`)} /> */}
            <div className={styles.company}>{company}</div>

            <div className={styles.appInfo}>
                <img className={styles.screenshot} src={screenshot} />
                <div className={styles.content}>
                    {!slogan ?
                        <img className={styles.logo} src={logo} />
                        :
                        <div className={styles.desc}>
                            <img className={styles.logo2} src={logo} />
                            <div>
                                <p className={styles.title}>{title}</p>
                                <p className={styles.slogan}>{slogan}</p>
                            </div>
                        </div>
                    }
                    <div className={styles.detail}>{detail}<br />
                    </div>
                    {/* {apk.length > 0 && <a className={styles.button} href={apk} ></a>}
                    {apk.length <= 0 && <a className={styles.button} onClick={this.toast} ></a>} */}
                </div>
            </div>
            <div className={styles.bottom}>
                <p className={styles.record}>
                    <a className={styles.url}>{icp}</a>
                    {/* { <a className={styles.url} href="http://www.beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">{icp}</a> */}
                    {/* {company}<br /> */}
                    地址：{protocolAddress || '北京市朝阳区双营路11号美立方6号楼1单元203'}<br />
                </p>
                {/* <p>
                    <a className={styles.url} href={`./qa/agreement?prdid=${prdid}`} target="_blank" rel="noopener noreferrer">用户协议</a>
                    <a className={styles.url} href={`./qa/policy?prdid=${prdid}`} target="_blank" rel="noopener noreferrer">隐私声明</a>
                </p> */}
            </div>
        </div>
    }
}

export default Index